module.exports = __webpack_public_path__ + "img/20240531_1.c99811e6.jpg";